import { OptionSubCategory } from 'owa-options-core';
import getSweepRules from 'owa-sweep-rules-option/lib/actions/getSweepRules';
import { getPrimaryMailFolders } from 'owa-folders';
import SweepRulesOption from 'owa-sweep-rules-option/lib/SweepRulesOption';

let sweepSubCategory: OptionSubCategory = {
    key: 'sweep',
    titleStringKey: 'optionSubcategory_sweep',
    options: [SweepRulesOption],
    onSelected: () => {
        getPrimaryMailFolders();
        // VSTS 24214: Keep old sweep rules on the screen while waiting for the reload
        return getSweepRules();
    },
};

export default sweepSubCategory;
